module.exports = __webpack_public_path__ + "static/media/large-success.6ccc880a.svg";